import { Injectable } from "@angular/core";
import {
    PopulateSeriesUsecase,
    PopulatePointsUsecase
} from "@arch/domain/application/usecase";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { CompanyEntity } from "@arch/domain/entity";

@Injectable({
    providedIn: "root"
})
export class PopulateDrillDownController {
    constructor(
        readonly populateSeriesUsecase: PopulateSeriesUsecase,
        readonly populatePointsUsecase: PopulatePointsUsecase
    ) {}

    public async execute(input: Input) {
        if (input.seriesIds?.length) {
            const seriesCreated = await this.populateSeriesUsecase.execute({
                company: input.company,
                seriesIdsById: input.seriesIds,
                seriesIdsByAssociated: [],
                options: {
                    includeAssociatedRaw: true
                }
            });
            if (seriesCreated?.length) {
                await this.populatePointsUsecase.execute({
                    company: input.company,
                    periodOptions: input.periodOptions,
                    options: {
                        seriesIds: input.seriesIds,
                        preserveMap: input.options?.preserveMap
                    }
                });
            }
        }
    }
}

type Input = {
    seriesIds?: string[];
    company: CompanyEntity;
    periodOptions?: VisualizationOptionsType;
    options?: {
        preserveMap?: boolean;
    };
};
